import { Card, Tooltip, Grid} from "@mui/material";
import "@fontsource/roboto-mono"; // Import the font
import {
  FaReact,
  FaJsSquare,
  FaPython,
  // FaHtml5,
  FaGithub,
} from "react-icons/fa"; // Import icons
import { DiRuby } from "react-icons/di";
import { SiRubyonrails, SiPostgresql } from "react-icons/si";
import { VscJson } from "react-icons/vsc";
import { GrHeroku } from "react-icons/gr";
import { IoLogoFirebase } from "react-icons/io5";
import { FaCss3Alt } from "react-icons/fa";
import { DiDjango } from "react-icons/di";
import { TbFileTypeHtml } from "react-icons/tb";




function Skills() {
  
  const skillIcons = [
    {
      icon: <FaJsSquare size="40" style={{ margin: "0 10px" }} />,
      title: "JavaScript"
    },
    {
      icon: <TbFileTypeHtml size="40" style={{ margin: "0 10px" }} />,
      title: "HTML"
    },
    {
      icon: <FaCss3Alt size="40" style={{ margin: "0 10px" }} />,
      title: "CSS"
    },
    {
      icon: <FaReact size="40" style={{ margin: "0 10px" }} />,
      title: "React"
    },
    {
      icon: <DiRuby size="40" style={{ margin: "0 10px" }} />,
      title: "Ruby"
    },
    {
      icon: <SiRubyonrails size="40" style={{ margin: "0 10px" }} />,
      title: "Rails"
    },
    {
      icon: <FaPython size="40" style={{ margin: "0 10px" }} />,
      title: "Python"
    },
    {
      icon: <DiDjango size="40" style={{ margin: "0 10px" }} />,
      title: "Django"
    },
    {
      icon: <SiPostgresql size="40" style={{ margin: "0 10px" }} />,
      title: "PostgreSQL"
    },
    {
      icon: <FaGithub size="40" style={{ margin: "0 10px" }} />,
      title: "GitHub"
    },
    {
      icon: <VscJson size="40" style={{ margin: "0 10px" }} />,
      title: "Json"
    },
    {
      icon: <GrHeroku size="40" style={{ margin: "0 10px" }} />,
      title: "Heroku"
    },
    {
      icon: <IoLogoFirebase size="40" style={{ margin: "0 10px" }} />,
      title: "Firebase"
    },
  ]


  return (
    // <Card
    //   style={{
    //     width: isMobile ? "100%" : "45%",
    //     height: "auto",
    //     margin: "0 auto",
    //     marginTop: "20px",
    //     padding: 3
    //   }}
    // >
    //   {" "}
    //   <Tooltip title="JavaScript" arrow>
    //     <span>
    //       <FaJsSquare size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="HTML" arrow>
    //     <span>
    //       <FaHtml5 size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="React" arrow>
    //     <span>
    //       <FaReact size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Ruby" arrow>
    //     <span>
    //       <DiRuby size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Rails" arrow>
    //     <span>
    //       <SiRubyonrails size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Python/Django/Flask" arrow>
    //     <span>
    //       <FaPython size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="PostgreSQL" arrow>
    //     <span>
    //       <SiPostgresql size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Git/GitHub" arrow>
    //     <span>
    //       <FaGithub size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Json" arrow>
    //     <span>
    //       <VscJson size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Heroku" arrow>
    //     <span>
    //       <GrHeroku size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    //   <Tooltip title="Firebase" arrow>
    //     <span>
    //       <IoLogoFirebase size="40" style={{ margin: "0 10px" }} />
    //     </span>
    //   </Tooltip>
    // </Card>

    <Card
      sx={{
        width: { xs: "100%", lg: "45%"},
        alignItems: "center", 
        justifyContent: "center",
        margin: "0 auto",
        mt: 2,
        pt: 1,
        pb: 1
      }}
    >
      <Grid
        container
        spacing={0}
      >
        {skillIcons.slice(0, -1).map((skill, index) => (
          <Grid 
            item
            key={index}
            xs={2} 
            sx={{
              display: "flex",
              justifyContent: "center", // Center items horizontally in each cell
            }}
          >
            <Tooltip title={skill.title} arrow>
              <div>{skill.icon}</div>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
      {/* <Box>
        {skillIcons[skillIcons.length - 1].icon}
      </Box> */}
    </Card>
  );
}

export default Skills;
